exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .basic-information{\n  background: #ffffff;\n  margin-left: 5rem;\n  margin-right: 5rem;\n  border-radius: 10px;\n  height: 42rem;\n} */\n.title{\n  padding-top: 1rem;\n}\n.row-btn-save{\n  padding-bottom: 1rem;\n}\n.message-field-require{\n  font-size: 2rem !important;\n}\n.vs__search{\n  height: 38px !important\n}\n.select-simple{\n  margin-top: 0rem !important;\n}\n.select-large input.vs-select--input{\n  height: 49px !important;\n}\n.vdp-datepicker input{\n  height: 49px !important;\n}\n.vx-row{\n  margin: 0;\n  padding-top: 1rem;\n}\n.vs-con-input-label{\n  width: 100%;\n}\n.vdp-datepicker input{\n  width: 100%;\n}\n", ""]);

// exports
